// extracted by mini-css-extract-plugin
export default {"planConnector":"QuotaInsurancePlanStep_planConnector__JDu80","planConnectorIcon":"QuotaInsurancePlanStep_planConnectorIcon__Rq19G"};